<template>
  <div class="watch">
    <div v-if="loading">
      Loading video...
    </div>

    <div v-else-if="video" style="height: 100vh">
      <Video ref="video" :url="video.url" :title="getVideoTitle" @onBack="back" @onEnd="back" @next="next"/>
    </div>

    <div v-else>
      Video not found
    </div>
  </div>
</template>

<script>

import { connect, io } from 'socket.io/client-dist/socket.io'

import config from '../config';

import Video from './Video.vue';

const token = localStorage.getItem('token')

export default {
  name: 'Watch',
  props: {
    session: Object
  },
  components: {
    Video
  },
  data() {
    return {
      loading: true,
      video: null
    }
  },
  methods: {
    back() {
      this.$router.push(`/shows/${this.video.showName}/${this.video.seasonName}`)
    },
    next() {
      this.$router.push(`/shows/${this.video.showName}/${this.video.seasonName}?next=1`)
    },
    getVideo() {
      const id = this.$route.params.id;

      this.axios.get(config.api + '/episodes/' + id, {
        headers: {
          'authorization': token
        }
      })
        .then(result => {
          this.video = result.data;
          this.loading = false;

          setTimeout(() => {
            if (id == this.session.lastVideoId)
              this.$refs.video.$refs.video.currentTime = this.session.lastVideoTimestamp

            this.$refs.video.$refs.video.click();
            this.$refs.video.$refs.video.play();
          }, 100);
        })
    },
    updateVideoTimestamp() {
      const videoElement = this.$refs.video.$refs.video;
      const timestamp = parseInt(videoElement.currentTime);
      const isPlaying = !videoElement.paused && !videoElement.ended && videoElement.readyState > 2 && videoElement.currentTime > 0;

      if (!isPlaying) {
        if (this.isShuttingDown) return;

        this.isShuttingDown = true;

        this.socketTimeout = setTimeout(() => {
          if (this.socket) this.socket.disconnect();
          this.socket = null;
        }, 120000);
        return;
      }

      this.axios.post(config.api + '/update_last_video_timestamp', { timestamp }, {
        headers: {
          'authorization': token
        }
      })

      const progress = timestamp / videoElement.duration;

      if (progress > .98) {
        this.next();
      }
    },
    initialize() {
      this.interval = setInterval(() => {
        this.updateVideoTimestamp();
      }, 5000);

      document.addEventListener('mousemove', () => {
        this.initializeSocket();
      })

      this.initializeSocket();
    },
    initializeSocket() {
      if (this.socket) return;

      this.isShuttingDown = false;

      this.socket = new io(config.api, {
        query: {
          authorization: token
        }
      });

      this.socket.on('play', () => {
        this.$refs.video.$refs.video.play();
      })

      this.socket.on('pause', () => {
        this.$refs.video.$refs.video.pause();
      })

      this.socket.on('next', () => {
        this.next();
      })

      this.socket.on('stop', () => {
        this.back();
      })
    }
  },
  computed: {
    getVideoTitle: function() {
      if (!this.video) return '';

      return `${this.video.name} - ${this.video.seasonName} - ${this.video.showName}`;
    }
  },
  created() {
    this.getVideo();
    this.initialize();
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.socket.disconnect();
  }
}
</script>

<style scoped>

.watch {
  height: 100vh;
  width: 100%;
  background: rgb(13,26,28);
  background: linear-gradient(146deg, rgba(13,26,28,1) 0%, rgba(70,70,70,1) 58%, rgba(43,41,41,1) 100%);
}

</style>



// WEBPACK FOOTER //
// src/components/Watch.vue